module.exports = __webpack_public_path__ + "img/art.c91ec770.svg";